// extracted by mini-css-extract-plugin
export default {"rating":"fK-z","numberOfStars":"gK-z","count":"hK-z","barGraphSpacing":"iK-z","barGraph":"jK-z"};